export default __webpack_public_path__ + "static/media/Sradhanjali Nayak.c1a3ca64.JPG";